/**
 * A BSB in the form it is printed in — `232-123`.
 *
 * Left exactly as stored when it is not six digits: a value that does not fit
 * the shape is one worth seeing verbatim on a review surface, not one to
 * reformat into looking correct.
 *
 * **Its own module only so the change-status layer can bind to it** (VALE-1174).
 * It lived in `compact-contact-detail.tsx`, which now imports
 * `change-status.ts` — and `change-status.ts` needs this formatter to print an
 * old bank account the reviewer can recognise, so leaving it there made the two
 * modules import each other. `compact-contact-detail.tsx` re-exports it, so
 * every existing import path still resolves.
 */
export function formatBsb(bsb: string | null | undefined): string | null {
  if (!bsb) return null;
  const digits = bsb.replace(/\D/g, '');
  return digits.length === 6 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : bsb;
}
